import { render, staticRenderFns } from "./BaseWrapper.vue?vue&type=template&id=3503fd0c&scoped=true"
import script from "./BaseWrapper.vue?vue&type=script&lang=js"
export * from "./BaseWrapper.vue?vue&type=script&lang=js"
import style0 from "./BaseWrapper.vue?vue&type=style&index=0&id=3503fd0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3503fd0c",
  null
  
)

export default component.exports